import { mmFetchWithResponse } from './mmFetchWithResponse';

const addressesApi = {
    getCountries: async (sort = false, sortOrder = 'desc') => {
        let url = `api/addresses/v1/countries?type=vendor`;
        if (sort) {
            url += `&sortOrder=${sortOrder}`;
        }
        return mmFetchWithResponse(url);
    },
};

export { addressesApi };
